// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BPWi","right":"styles_right__h96Qb"};